import { createRoot } from "react-dom/client";
import "@fontsource/instrument-serif/400.css";
import "@fontsource/instrument-serif/400-italic.css";
import App from "./App.tsx";
import "./index.css";
import { initAdobeFonts } from "./lib/adobeFonts";
import { initTracking } from "./lib/tracking";

// Recover from stale code-split chunks (after a deploy or dev-server restart)
// by reloading once instead of leaving a blank screen.
const RELOAD_KEY = "h2h-chunk-reload";
const recoverFromChunkError = () => {
  if (sessionStorage.getItem(RELOAD_KEY)) return;
  sessionStorage.setItem(RELOAD_KEY, "1");
  window.location.reload();
};
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  recoverFromChunkError();
});
const CHUNK_ERROR_RE = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;
window.addEventListener("unhandledrejection", (e) => {
  const msg = String(e.reason?.message ?? e.reason ?? "");
  if (CHUNK_ERROR_RE.test(msg)) recoverFromChunkError();
});
// React.lazy rethrows the failed import during render → surfaces as a window "error".
window.addEventListener("error", (e) => {
  const msg = String(e.error?.message ?? e.message ?? "");
  if (CHUNK_ERROR_RE.test(msg)) recoverFromChunkError();
});
window.addEventListener("load", () => {
  setTimeout(() => sessionStorage.removeItem(RELOAD_KEY), 10000);
});

initAdobeFonts();
initTracking();

const root = document.getElementById("root");
if (root) createRoot(root).render(<App />);
